import { BigNumber, utils } from 'ethers'
import { EarnInfo, TokenInfo } from '~/contracts/useEarnContract'

export const toFloat = (value: BigNumber, decimals: number) =>
	Number.parseFloat(utils.formatUnits(value, decimals))

export const apy = (apr: number) => Math.pow(1 + apr / 365, 365) - 1

export const apr = (
	token: TokenInfo,
	earn: EarnInfo,
	secondsPerBlock: number,
) => {
	const reserves0 = toFloat(token.reserves[0], token.decimals) // Gas token
	const reserves1 = toFloat(token.reserves[1], token.decimals) // SIS
	const sisPriceInGas = reserves0 / reserves1
	const lpTotalSupply = toFloat(token.totalSupply, token.decimals) // total LP supply
	const lpPriceInGas = (reserves0 + reserves1 * sisPriceInGas) / lpTotalSupply

	const poolAllocPoint = toFloat(earn.poolInfo.allocPoint, token.decimals)
	const totalAllocPoint = toFloat(earn.totalAllocPoint, token.decimals)

	const masterBalanceInLp = toFloat(token.balanceOfMaster, token.decimals)
	const masterBalanceInGas = lpPriceInGas * masterBalanceInLp

	const blocksPerYear = (86400.0 / secondsPerBlock) * 365
	const rewardPerBlock = toFloat(earn.rewardPerBlock, token.decimals)
	const rewardsPerYearInSis = rewardPerBlock * blocksPerYear
	const rewardsPerYearInGas = rewardsPerYearInSis * sisPriceInGas

	return rewardsPerYearInGas * poolAllocPoint / totalAllocPoint / masterBalanceInGas

}
